angular.module('Itao.IndicatorMap').directive('indicatorMap', function (mapConfig) {
  'use strict';
  return {
    templateUrl: mapConfig.templateBasePath + 'map.html',
    controller: 'IndicatorMapController',
    scope: {
      districts: '=',
      selectedDistricts: '=',
      layers: '=',
      config: '=',
      indicators: '=',
      selectedIndicators: '=',
      selectedDataLayer: '=',
      colorSets: '=',
      indicatorSets: '=',
      poiLayers: '=',
      poiLayerTypes: '=',
      selectedPoiLayer: '=',
      poiData: '=',
      selectDistrict: '&',
      singleSelectDistrict: '&',
      deselectDistrict: '&',
      dimensionX: '@',
      dimensionY: '@',
      blToZoom: '='
    },
    link: function (scope, element, attrs) {

    }
  };
});
